import React from "react";
import {
  Edit,
  SimpleForm,
  Toolbar,
  TextField,
  SelectInput,
  ReferenceInput,
  NumberInput,
  number,
  minValue,
  maxValue,
} from "react-admin";
import CancelButton from "../common/CancelButton";
import SaveButton from "../common/SaveButton";

const validateInteger = (value, allValues, props) => {
  if (value && !Number.isInteger(value)) {
    return props.translate("ra.validation.integer");
  }
};

const validateCapacity = [
  number(),
  minValue(1),
  maxValue(9999),
  validateInteger,
];

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <CancelButton />
  </Toolbar>
);

const ResourceEdit = (props) => (
  <Edit {...props}>
    <SimpleForm toolbar={<EditToolbar />} submitOnEnter={false}>
      <TextField source="name" />
      <TextField source="email" />
      <TextField source="resourceGroupName" />
      <NumberInput source="capacity" validate={validateCapacity} />
      <ReferenceInput
        source="operationRuleId"
        reference="operation-rules"
        sort={{ field: "name", order: "ASC" }}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <SelectInput
        source="isMonitored"
        label="resources.resources.fields.isMonitored"
        choices={[
          { id: true, name: "resources.resources.enums.monitoring.true" },
          { id: false, name: "resources.resources.enums.monitoring.false" },
        ]}
      />
    </SimpleForm>
  </Edit>
);

export default ResourceEdit;
